
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./authContext";

export const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAdmin, loading } = useContext(AuthContext);

  if (loading) {
    return <p></p>;
  }

  if (!isAuthenticated) {
    // per utente generico non autenticato
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    // se qualcuno va in zona admin e non deve 
    return <Navigate to="/" replace />;
  }


  
  return children;
};

export const GuestRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);

  if (loading) {
    return <p></p>;
  }

  if (isAuthenticated) {
    
    return <Navigate to="/" replace />;
  }

  return children;
};


